.section {
	grid-column: span 12;
}

.headerBar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 12px;
}

.title {
	margin: 0;
	font-size: 15px;
	font-weight: 600;
	color: #111827;
}

.error {
	color: #d14343;
	margin: 0 0 8px;
	font-size: 13px;
}

.table {
	display: flex;
	flex-direction: column;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	overflow: hidden;
	background: #fafafa;
}

.headerRow {
	display: grid;
	grid-template-columns: 1.5fr 1.5fr 1.2fr 70px;
	gap: 8px;
	padding: 8px 12px;
	border-bottom: 1px solid #e5e7eb;
	color: #6b7280;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.03em;
	background: #f9fafb;
}

.row {
	display: grid;
	grid-template-columns: 1.5fr 1.5fr 1.2fr 70px;
	gap: 8px;
	align-items: center;
	padding: 8px 12px;
	border-bottom: 1px solid #f1f3f5;
	background: #fff;

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		background: #f9fafb;
	}
}

.cell {
	min-width: 0;
}

.cellCompact {
	min-width: 0;
}

.cellSwitch {
	display: flex;
	align-items: center;
	justify-content: center;
}

.cellActions {
	display: flex;
	justify-content: flex-end;
}

.muted {
	color: #9ca3af;
	font-size: 12px;
	text-align: center;
}

.buttonContainer {
	display: flex;
	justify-content: flex-start;
	margin-top: 12px;
}
